import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ModalModule} from 'ng2-bootstrap/modal';

import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ModalEditNodeComponent} from './modal-edit-node.component';

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    FormsModule,
    SearchBarModule,
  ],
  declarations: [
    ModalEditNodeComponent,
  ],
  exports: [
    ModalEditNodeComponent,
  ],
})
export class ModalEditNodeModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/modal-edit-node/modal-edit-node.module.ts